module.exports = __webpack_public_path__ + "img/antes_despues_44.c75e5144.png";